// Componente tareasPend.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="2"> 
              <b-form-checkbox
                v-model="datosFormulario.cktermincancel"
                value="1"
                unchecked-value="0"
                @change="asgcktermincancel"
                >
                Terminadas / Canceladas 
              </b-form-checkbox>
            </b-col>
            <b-col lg="4"> 
            <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;" size="sm"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datatareas"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                  </el-table-column>

                  <!-- <el-table-column  label="" min-width="100px" align="center">
                    <template v-slot="scope">
                      <b-button size="sm" variant="primary" @click="recuperar_detpoliza(scope.row.poliza, 1, scope.row.endoso)" >Detalle</b-button>
                    </template>
                  </el-table-column>

                  <el-table-column  label="" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <b-button size="sm" variant="primary" @click="mail_copianovalida(scope.row.poliza, scope.row.endoso)" >Generar mail</b-button>
                    </template>
                  </el-table-column> -->
                  
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Póliza"
      cancel-title="Cancelar"
      v-model="modaldetpoliza"
      @cancel="modaldetpoliza = false"
    >
        <center><h5>COPIA NO VALIDA</h5></center>
        <p><b>Riesgo: </b> {{ this.datosFormulario.producto }} </p>
        <p><b>Póliza: </b> {{ this.datosFormulario.poliza }} <b>Propuesta:</b> {{ this.datosFormulario.propuesta }} <b>Sucursal:</b> {{ this.datosFormulario.sucursal }} </p>
        <p><b>Moneda: </b> {{ this.datosFormulario.moneda }} </p>
        <p><b>Corredor: </b> {{ this.datosFormulario.corredor }} <b>Rut: </b> {{ this.datosFormulario.rutnumcorred }}-{{ this.datosFormulario.rutdvcorred}} <b>Código: </b> {{ this.datosFormulario.codigocorred}}</p>
        <p><b>Contratante: </b> {{ this.datosFormulario.contratante }} <b>Rut: </b> {{ this.datosFormulario.rutnumcon }}-{{ this.datosFormulario.rutdvcon}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direccon }} </p>
        <p><b>Item: </b> {{ this.datosFormulario.item }} <b>Endoso: </b> {{ this.datosFormulario.endoso }}</p>
        <p><b>Asegurado: </b> {{ this.datosFormulario.asegurado }} <b>Rut: </b>{{ this.datosFormulario.rutnumaseg}}-{{ this.datosFormulario.rutdvaseg}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direcaseg }} </p>
        <p><b>Vig. Desde: </b> {{ this.datosFormulario.vigdesde }} <b>Vig. Hasta: </b> {{ this.datosFormulario.vighasta }}</p>
        <p><b>Acción: </b> {{ this.datosFormulario.accion }} </p>
        <br>
        <table class="table">
          <tr>
          <td align ="center"><b>Monto asegurado</b></td>		<td align ="center"><b>Prima neta</b></td>	<td align ="center"><b>IVA</b></td>
          </tr>
          <tr>
          <td align ="center">{{this.datosFormulario.montoaseg}}</td>		<td align ="center">{{this.datosFormulario.primaneta}}</td>	<td align ="center">{{this.datosFormulario.iva}}</td>
          </tr>
        </table>
        <br>
        <center><p><b>Detalle de Materia Asegurada</b></p></center>
        <p>{{this.datosFormulario.materia}}</p>
        <br>
        <p><b>Póliza</b> {{ this.datosFormulario.poliza }} <b>Endoso</b> {{ this.datosFormulario.endoso }} <b>Item</b> {{ this.datosFormulario.item }}  </p>
        <p><b>Firma Autorizada</b> </p>
        <br>
        <center><p><b>Observaciones</b></p></center>
        {{this.datosFormulario.observaciones}}

      
      <b-row>
 
      </b-row>
    </b-modal>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
// import apiRegCorrespon from "@/components/services/apiRegCorrespon";
import apiTareas from "@/components/services/apiTareas";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Polizas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    // title: { type: String },
    nroSiniestro: String,
    poliza: String,
    // timeOnSite: { type: Number, required: true }
  },

  data: function() {
    return {
      datatareas:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modaldetpoliza: false,
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },

      nombreexcel: "Tareas Pendientes",

      datosFormulario: {
        cktermincancel:"0",
        producto: "",
        poliza: "",
        endoso: "",
        item: "",
        propuesta: "",
        accion: "",
        moneda: "",
        vigdesde: "",
        vighasta: "",
        montoaseg: "",
        primaneta: "",
        iva: "",
        materia: "",
        sucursal: "",
        corredor: "",
        rutnumcorred: "",
        rutdvcorred: "",
        codigocorred: "",
        asegurado: "",
        direcaseg: "",
        ciudadaseg: "",
        rutnumaseg: "",
        rutdvaseg: "",
        contratante: "",
        rutnumcon: "",
        rutdvcon: "",
        direccon: "",
        ciudadcon: "",
        observaciones: "",
      },
      
      titles: [
        {
          prop: "asistente",
          label: "Asistente",
          align: "center",
          minwidth:'60'
        },
        {
          prop: "ejecutivo",
          label: "Ejecutivo",
          align: "center",
          minwidth:'60'
        },
        {
          prop: "tarea",
          label: "Tarea",
          align: "left",
          minwidth:'100'
        },      
        {
          prop: "actividad",
          label: "Actividad",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "siniestro",
          label: "Siniestro",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "asegurado",
          label: "Asegurado",
          align: "left",
          minwidth:'120'
        },      
        {
          prop: "deudor",
          label: "Deudor",
          align: "left",
          minwidth:'120'
        },      
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "observacion",
          label: "Observacion",
          align: "lesf",
          minwidth:'100'
        },      
        // {
        //   prop: "costo",
        //   label: "Costo",
        //   align: "right",
        //   minwidth:'100'
        // },      
        // {
        //   prop: "corredor",
        //   label: "Corredor",
        //   align: "center",
        //   minwidth:'100'
        // }
        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {

        formatter(row, column) {
          if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
        },

        asgcktermincancel(checked){

          this.recuperar_histtarea(checked);

        },

        recuperar_histtarea(p_termcanc){
        return apiTareas
            .recuperar_histtarea(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.poliza,
            this.nroSiniestro,
            p_termcanc
            )  
            .then(response => {

                response.data = this.keysMinuscula(response.data);
                
                this.datatareas = response.data.tareas;

                 
                 
                 
                 
                 
                    this.$Progress.finish();
                })
                .catch(error => {
                    this.mensaje= error;
                    this.variant="warning";
                    this.showAlert = true;
                    this.$Progress.finish();
                });

        },

        

      
        descargarExcel: function () {
        var cuerpo = "";
        var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
        var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
        var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

        cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=80 style='width:60pt'>";
        cuerpo += "\n";

        
        ///COLUMNAS ESCRIBIR
        cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Asistente" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ejecutivo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Tarea" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Actividad" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Póliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Siniestro" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Asegurado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Deudor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Estado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Observación" + "</td>\n";
        cuerpo += "</tr>\n";
        
        //Data bloque 1
        
        for (var key in this.datatareas) {
          if(this.datatareas[key]["asistente"] === undefined){ 
            this.datatareas[key]["asistente"] = "";
          }
          if(this.datatareas[key]["ejecutivo"] === undefined){ 
            this.datatareas[key]["ejecutivo"] = "";
          }
          
          if(this.datatareas[key]["tarea"] == undefined){ 
            this.datatareas[key]["tarea"] = "";
          }
          if(this.datatareas[key]["actividad"] == undefined){ 
            this.datatareas[key]["actividad"] = "";
          }
          if(this.datatareas[key]["poliza"] == undefined){ 
            this.datatareas[key]["poliza"] = "";
          }
          if(this.datatareas[key]["siniestro"] == undefined){ 
            this.datatareas[key]["siniestro"] = "";
          }
          if(this.datatareas[key]["asegurado"] == undefined){ 
            this.datatareas[key]["asegurado"] = "";
          }
          if(this.datatareas[key]["deudor"] == undefined){ 
            this.datatareas[key]["deudor"] = "";
          }
          if(this.datatareas[key]["estado"] == undefined){ 
            this.datatareas[key]["estado"] = "";
          }
          if(this.datatareas[key]["observacion"] == undefined){ 
            this.datatareas[key]["observacion"] = "";
          }
          

          cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["asistente"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["ejecutivo"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["tarea"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["actividad"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["poliza"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["siniestro"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["asegurado"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["deudor"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["estado"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datatareas[key]["observacion"] + "</td>\n";
          cuerpo += "</tr>\n";
        }

        //Data bloque 1
        
        this.export(
          this.generaExcelV2(this.nombreexcel, cuerpo),
          this.nombreexcel
        );
      },

      export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },
    
  },
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_histtarea(0);
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>